import moment from 'moment';

const fetchJson = async (url, options = {}) => {
  const defaultOptions = {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    ...options,
  };

  const response = await fetch(url, defaultOptions);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const data = await response.json();
  return data;
};

export function getSavedreports() {
  return fetchJson('/reporting/saved').then(data => data.response);
}

export function deleteSavedReport(id) {
  const url = `/reporting/saved?id=${id}`;
  return fetchJson(url, { method: 'DELETE' });
}

export function deleteScheduledReport(id) {
  const url = `/reporting/scheduled?id=${id}`;
  return fetchJson(url, { method: 'DELETE' });
}

export function toggleActiveScheduledReport({ id, active }) {
  const url = `/reporting/scheduled/deactive?id=${id}&active=${active}`;
  return fetchJson(url, { method: 'PUT' });
}

export function postNewOutbox(obj) {
  return fetchJson('/account/outbox', {
    method: 'POST',
    body: JSON.stringify(obj),
  })
    .then(() => fetchJson('/account/outbox'))
    .then(data => data);
}

export function sendSavedReport(obj) {
  return fetchJson('/run/send/report/', {
    method: 'POST',
    body: JSON.stringify(obj),
  }).then(data => data);
}

export function createSavedreport(obj) {
  return fetchJson('/reporting/saved', {
    method: 'POST',
    body: JSON.stringify(obj),
  }).then(() => getSavedreports());
}

export function postScheduledReport(obj) {
  return fetchJson('/reporting/scheduled', {
    method: 'POST',
    body: JSON.stringify(obj),
  })
    .then(() => fetchJson('/reporting/scheduled'))
    .then(data => data);
}

export function updateScheduledReport(obj) {
  return fetchJson('/reporting/scheduled', {
    method: 'PUT',
    body: JSON.stringify(obj),
  });
}

export function updateSavedReport(id, obj) {
  return fetchJson(`/reporting/saved/schema?id=${id}`, {
    method: 'PUT',
    body: JSON.stringify(obj),
  });
}

export function getReportType() {
  return fetchJson('/reporting/types').then(data => data.response);
}

export function getAllSegments() {
  return fetchJson('/segments?format=json').then(data => data.response);
}

export function getScheduledreports() {
  return fetchJson('/reporting/scheduled').then(data => data.response);
}

export function getOutboxes() {
  return fetchJson('/account/outbox/data').then(data => data.response);
}

export function getOutboxById(id) {
  return fetchJson(`/account/outbox?id=${id}`).then(data => data.response);
}

export function getOutboxWithoutDetails() {
  return fetchJson('/account/outbox').then(data => data.response);
}

export function getReportingTypes() {
  return fetchJson('/reporting/types').then(data => data.response);
}

export function forceSendOnce(report) {
  const {
    pixel_source_name,
    report_type_id,
    destination,
    filter_id,
    outbox_id,
    id,
  } = report;

  return fetchJson('/reporting/send', {
    method: 'POST',
    body: JSON.stringify({
      scheduled_report_id: id,
      report_type_id,
      advertiser: pixel_source_name,
      destination,
      outbox_id,
      filter_id,
      date: moment.utc()
        .utcOffset(-5)
        .subtract(1, 'days')
        .format('YYYY-MM-DD'),
      num_days: report.num_days,
    }),
  });
}
